export enum ApiMethod {
    POST = "POST",
    PUT = "PUT"
}